import {environment} from "../../environments/environment";

declare var process

class ApiKeysLocal {
    static readonly GOOGLE_MAPS = 'AIzaSyDywqR0Kcu5F7E5kQ9zkA0xdTv_WU0AXaA'
}

class ApiKeysDevelopment {
    static readonly GOOGLE_MAPS = 'AIzaSyDywqR0Kcu5F7E5kQ9zkA0xdTv_WU0AXaA'
}

class ApiKeysStage {
    static readonly GOOGLE_MAPS = 'AIzaSyDywqR0Kcu5F7E5kQ9zkA0xdTv_WU0AXaA'
}

class ApiKeysProduction {
    static readonly GOOGLE_MAPS = 'AIzaSyDywqR0Kcu5F7E5kQ9zkA0xdTv_WU0AXaA'
}

let temp

switch (environment.name) {
    case 'local':
        temp = ApiKeysLocal
        break
    case 'stage':
        temp = ApiKeysStage
        break
    case 'development':
        temp = ApiKeysDevelopment
        break
    case 'production':
        temp = ApiKeysProduction
        break
}

export const ApiKeys = temp




// WEBPACK FOOTER //
// /app/src/shared/constants/api-keys.ts